import {Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,} from "@mui/material";
import React from "react";
import {HandResultItem, Result} from "../../../../types/pj1dbApiHandling";
import HandListItem, {HandListItemProps} from "./HandListItem";
import {roundNum} from "../../../../utils/numberUtil";
import {HandDocument} from "../../../equipmentdb/types/pj1dbApiHand";
import {FingertipDocument} from "../../../equipmentdb/types/pj1dbApiFingertip";

export interface HandGroupListItemProps {
  group: Result;
  hands: HandDocument[];
  fingertips: FingertipDocument[];
  onSelectHand: HandListItemProps['onSelect'];
}

export default function HandGroupListItem(props: HandGroupListItemProps) {
  return (
    <Box display='flex' flexWrap={{ xs: 'wrap', sm: 'nowrap'}} gap={2}>
      <Box>
        <ScoreTable score={props.group.score}/>
      </Box>
      <Box display='flex' flexWrap='wrap' gap={2}>
        {convert(props).map(data => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <HandListItem {...data} key={JSON.stringify(data)} onSelect={props.onSelectHand}/>
        ))}
      </Box>
    </Box>
  )
}

function ScoreTable(props: { score: HandResultItem['score'] }) {
  return (
    <TableContainer component={Paper} sx={{width: 'fit-content', height: 'fit-content', textWrap: 'nowrap'}}>
      <Table size="small">
        <TableHead sx={{bgcolor: "#EEE"}}>
          <TableRow>
            <TableCell align='center' sx={{px: 1, py: 0.5}}>評価基準</TableCell>
            <TableCell align='center' sx={{px: 1, py: 0.5}}>評価点</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TRow label='総合評価値' value={props.score.total}/>
          <TRow label='把持力' value={props.score.force}/>
          <TRow label='把持幅' value={props.score.open}/>
          <TRow label='ストローク' value={props.score.stroke}/>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

function TRow({label, value}: { label: string, value: number }) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <TableRow sx={{'&:last-child td, &:last-child th': {border: 0}}}>
      <TableCell align='center' sx={{px: 1, py: 0.5, textWrap: 'nowrap'}}>{label}</TableCell>
      <TableCell align='center' sx={{px: 1, py: 0.5, textWrap: 'nowrap'}}>{`${roundNum(value ?? 0)} 点`}</TableCell>
    </TableRow>
  )
}


function convert(params: {
  group: Result,
  hands: HandDocument[],
  fingertips: FingertipDocument[],
}): {
  item: HandResultItem,
  hand: HandDocument,
  fingertip: FingertipDocument | undefined,
}[] {
  return params.group.hands
    .filter(item => params.hands.find(h => h.attr.handId === item.handID) !== undefined)
    .map(item => ({
      item,
      hand: params.hands.find(h => h.attr.handId === item.handID)!,
      fingertip: 'fingertipID' in item
        ? params.fingertips.find(f => f.attr.fingertipId === item.fingertipID)
        : undefined,
    }));
}
